import sanity from "../sanity";
import { ContactInfos } from "../typings"

const query = `
    *[_type == "contactInfos"][0]
`

export const fetchContactInfos = ():Promise<ContactInfos> => sanity.fetch(query)